import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { Icons } from "atoms/constants/icons";
import { ParagraphSizes } from "atoms/constants/paragraph-sizes";
import TextInput from "atoms/forms/text-input";
import Icon from "atoms/icons/icon";
import Paragraph from "atoms/typography/paragraph";
import { t } from "i18next";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import { CollectionUtils } from "utilities/collection-utils";

const CSS_CLASS_NAME = "c-notebook-block-selector";

interface NotebookBlockSelectorListProps {
    records?: { name: string; id?: number }[];
    newRecordName?: string;
    onExistingRecordClick: (id?: number) => void;
    onNewRecordNameChanged: (notebookName: string) => void;
    createButtonText: string;
    helpText: ReactNode;
    selectedRecordId?: number;
}
const NotebookBlockSelectorList = ({
    records,
    onExistingRecordClick,
    helpText,
    selectedRecordId,
    createButtonText,
    newRecordName,
    onNewRecordNameChanged,
}: NotebookBlockSelectorListProps) => {
    const [showNewRecordField, setShowNewRecordField] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (showNewRecordField) {
            inputRef.current?.focus();
        }
    }, [showNewRecordField]);

    return (
        <>
            <Paragraph size={ParagraphSizes.Small}>{helpText}</Paragraph>
            <ul className={`${CSS_CLASS_NAME}__list`}>
                {CollectionUtils.hasValues(records)
                    ? records.map((record) => (
                          <li
                              className={`${CSS_CLASS_NAME}__list-item ${record.id === selectedRecordId ? "-selected" : ""}`}
                              key={record.id}>
                              <Button
                                  style={ButtonStyles.None}
                                  cssClassName={`${CSS_CLASS_NAME}__list-item-button`}
                                  onClick={() => {
                                      onNewRecordNameChanged("");
                                      setShowNewRecordField(false);
                                      onExistingRecordClick(record.id!);
                                  }}>
                                  {record.name}
                              </Button>
                          </li>
                      ))
                    : t("noOptionsAvailable")}
                <li>
                    {showNewRecordField ? (
                        <TextInput
                            ref={inputRef}
                            cssClassName={`${CSS_CLASS_NAME}__text-field`}
                            onChange={(e) => {
                                onExistingRecordClick(undefined);
                                onNewRecordNameChanged(e.target.value ?? "");
                            }}
                            value={newRecordName}
                            maxLength={60}
                            id={"new-record-name-text-input"}
                        />
                    ) : (
                        <Button
                            style={ButtonStyles.None}
                            cssClassName={`${CSS_CLASS_NAME}__list-item-button -create`}
                            onClick={() => {
                                setShowNewRecordField(true);
                            }}>
                            <Icon type={Icons.Plus} />
                            {createButtonText}
                        </Button>
                    )}
                </li>
            </ul>
        </>
    );
};

export default NotebookBlockSelectorList;
